import React from 'react'
import { useList } from 'effector-react'
import { $modalsList } from '/components/common/modal/model'
import { Modal } from '/components/common/modal/index'

export const ModalStack = (): JSX.Element => {
  return useList($modalsList, (modal) => <Modal {...modal} />)
}
